<template>
  <div
    class="flex flex-col items-center gap-sm grow justify-center self-center w-1/3"
    data-test="empty-docs-list"
  >
    <div class="rocket">
      <img :src="rocket">
    </div>
    <span class="typography-headline-2">
      {{ $t('noDocs.main') }}
    </span>
    <span class="typography-body-2-regular">
      {{ $t('noDocs.secondary') }}
    </span>
  </div>
</template>
<script setup lang="ts">
import rocket from '../assets/rocket.png';
</script>
